var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeImage2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 373.2 237.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 178.92,
    y1: 263.76,
    x2: 183.96,
    y2: 114.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8e0fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f7f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 293.14,
    y1: 337.93,
    x2: 151.3,
    y2: 106.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c86fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ef0fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 242.19,
    y1: -44.63,
    x2: 252.7,
    y2: -73.12,
    gradientTransform: "translate(290.24 -214.56) rotate(108.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#beccfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f7f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 59.16,
    y1: 191.22,
    x2: 58.46,
    y2: 39.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8e0fd",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f7f9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.08,
    dy: 5.13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 4.1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#383899",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 71.71,
    y1: 89.33,
    x2: 46.71,
    y2: 32.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#df6891"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#df8ce0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 58.31,
    y1: 224.11,
    x2: 58.78,
    y2: 179.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebb02a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3d478"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.08,
    dy: 5.13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 4.1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#383899",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-3",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.03,
    dy: 1.03
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 1.03
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ae4747",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 27.96,
    y1: 186.46,
    x2: 26.47,
    y2: 178.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 25.87,
    y1: 178.69,
    x2: 28.54,
    y2: 186.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9fb0fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f7f9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-4",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.03,
    dy: 1.03
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4",
    stdDeviation: 1.03
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ae4747",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-4",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 35.75,
    y1: 201.95,
    x2: 34.26,
    y2: 194.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 33.66,
    y1: 194.18,
    x2: 36.33,
    y2: 201.76,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 305.8,
    y1: 239.58,
    x2: 306.62,
    y2: 160.9,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-5",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.08,
    dy: 5.13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-5",
    stdDeviation: 4.1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#383899",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-5",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 306.3,
    y1: 209.42,
    x2: 306.75,
    y2: 165.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8066ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d58bf7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 329.72,
    y1: 167.82,
    x2: 329.86,
    y2: 154.27,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 307.87,
    y1: 124.26,
    x2: 305.77,
    y2: 45.79,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-6",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.08,
    dy: 5.13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-6",
    stdDeviation: 4.1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#383899",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-6",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 303.46,
    y1: 74.23,
    x2: 303.68,
    y2: 52.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#de5d83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebb083"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-7",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.03,
    dy: 2.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-7",
    stdDeviation: 2.05
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#c94e33",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-7",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-8",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.03,
    dy: 2.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-8",
    stdDeviation: 2.05
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#c94e33",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-8",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 298.43,
    y1: 98.9,
    x2: 289.67,
    y2: 83.05,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 270.71,
    y1: 105.75,
    x2: 277.48,
    y2: 89.17,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 341.52,
    y1: 95.28,
    x2: 331.1,
    y2: 83.36,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 326.51,
    y1: 101.41,
    x2: 321.49,
    y2: 89.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#80c3e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a3ffec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 173.84,
    y1: 65.33,
    x2: 174.37,
    y2: 36.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e2a82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e2a82",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-9",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.08,
    dy: 5.13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-9",
    stdDeviation: 4.1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#383899",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-9",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 138.95,
    y1: 63.37,
    x2: 138.77,
    y2: 49.45,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 156.1,
    y1: 61.89,
    x2: 156.28,
    y2: 49.19,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 173.89,
    y1: 64.53,
    x2: 173.46,
    y2: 49.82,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 190.95,
    y1: 64.57,
    x2: 190.86,
    y2: 50.12,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 208.81,
    y1: 64.8,
    x2: 207.5,
    y2: 50.61,
    xlinkHref: "#linear-gradient-19"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.71,85.75V237.73H45.04V85.75c0-3.99,3.23-7.24,7.24-7.24H312.48c3.99,0,7.23,3.24,7.23,7.24Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.36,
    y: 85.09,
    width: 260.02,
    height: 144.74,
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 63.85,
    y: 97.08,
    width: 83.66,
    height: 58.86,
    rx: 8.41,
    ry: 8.41,
    style: {
      fill: "#72c2fc",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.85,
    y: 162.48,
    width: 173.84,
    height: 58.86,
    rx: 8.41,
    ry: 8.41,
    style: {
      fill: "#72c2fc",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.03,
    y: 97.08,
    width: 83.66,
    height: 58.86,
    rx: 8.41,
    ry: 8.41,
    style: {
      fill: "#72c2fc",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.03,
    y: 97.08,
    width: 59.21,
    height: 27.33,
    rx: 8.41,
    ry: 8.41,
    style: {
      fill: "#72c2fc",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.03,
    y: 130.79,
    width: 59.21,
    height: 90.54,
    rx: 8.41,
    ry: 8.41,
    style: {
      fill: "#72c2fc",
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M255.33,59.17c1.36,.45,2.74,.77,4.11,.98l3.2,8.37,15.42-3.25-.45-8.95c2.36-1.51,4.48-3.4,6.27-5.62l8.85,1.41,4.89-14.98-7.97-4.08c-.13-2.85-.73-5.63-1.74-8.24l5.65-6.96-10.53-11.73-7.53,4.86c-1.23-.64-2.53-1.19-3.9-1.63s-2.74-.77-4.11-.98l-3.2-8.37-15.42,3.25,.45,8.95c-2.36,1.51-4.48,3.4-6.27,5.62l-8.85-1.41-4.89,14.98,7.97,4.08c.13,2.85,.73,5.63,1.74,8.24l-5.65,6.96,10.53,11.73,7.53-4.87c1.23,.64,2.53,1.19,3.89,1.63Zm4.72-10.6c-8.84-2.14-13.64-11.6-10.15-19.99,2.75-6.6,10.03-10.3,16.99-8.62,8.84,2.14,13.64,11.6,10.15,19.99-2.75,6.6-10.03,10.3-16.99,8.62Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.37,
    y: 18.52,
    width: 98.57,
    height: 126.13,
    rx: 12.15,
    ry: 12.15,
    style: {
      fill: "url(#linear-gradient-4)",
      filter: "url(#drop-shadow-1)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M80.43,59.79c0,6.22-2.59,11.8-6.74,15.77-3.91,3.73-9.2,6.02-15.03,6.02s-11.09-2.28-15-6.02c-4.17-3.95-6.77-9.56-6.77-15.77,0-12.02,9.75-21.77,21.77-21.77s21.77,9.75,21.77,21.77Z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.79,51.51c0,3.94-3.19,7.14-7.14,7.14s-7.14-3.19-7.14-7.14,3.19-7.14,7.14-7.14,7.14,3.19,7.14,7.14Z",
    style: {
      fill: "#f5f7f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.68,75.57c-3.91,3.73-9.2,6.02-15.03,6.02s-11.09-2.28-15-6.02c1.76-6.63,7.82-11.53,15-11.53s13.25,4.9,15.03,11.53Z",
    style: {
      fill: "#f5f7f9"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.83,105.82H33.48c-2.66,0-4.82-2.16-4.82-4.82h0c0-2.66,2.16-4.82,4.82-4.82h50.35c2.66,0,4.82,2.16,4.82,4.82h0c0,2.66-2.16,4.82-4.82,4.82Z",
    style: {
      fill: "#9f9ffb",
      mixBlendMode: "multiply",
      opacity: 0.71
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.67,
    y: 112.03,
    width: 59.98,
    height: 9.63,
    rx: 4.82,
    ry: 4.82,
    style: {
      fill: "#9f9ffb",
      mixBlendMode: "multiply",
      opacity: 0.71
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 45.21,
    y: 129.75,
    width: 26.88,
    height: 4.04,
    style: {
      fill: "#9f9ffb",
      mixBlendMode: "multiply",
      opacity: 0.71
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M18.96,169.69H98.37c4,0,7.24,3.24,7.24,7.24v26.28c0,4-3.24,7.24-7.24,7.24H18.96c-4,0-7.24-3.24-7.24-7.24v-26.28c0-4,3.24-7.24,7.24-7.24Z",
    style: {
      fill: "url(#linear-gradient-6)",
      filter: "url(#drop-shadow-2)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.13,186.82h-7.97c-2.48,0-4.5-2.01-4.5-4.5h0c0-2.48,2.01-4.5,4.5-4.5h7.97c2.48,0,4.5,2.01,4.5,4.5h0c0,2.48-2.01,4.5-4.5,4.5Z",
    style: {
      fill: "#c15f5f",
      mixBlendMode: "multiply",
      opacity: 0.32
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#drop-shadow-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.44,182.32c0,2.92-2.37,5.3-5.3,5.3s-5.3-2.37-5.3-5.3,2.37-5.3,5.3-5.3,5.3,2.37,5.3,5.3Z",
    style: {
      fill: "url(#linear-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.89,182.32c0,2.07-1.68,3.74-3.74,3.74s-3.74-1.68-3.74-3.74,1.68-3.74,3.74-3.74,3.74,1.68,3.74,3.74Z",
    style: {
      fill: "url(#linear-gradient-8)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.13,202.31h-7.97c-2.48,0-4.5-2.01-4.5-4.5h0c0-2.48,2.01-4.5,4.5-4.5h7.97c2.48,0,4.5,2.01,4.5,4.5h0c0,2.48-2.01,4.5-4.5,4.5Z",
    style: {
      fill: "#c15f5f",
      mixBlendMode: "multiply",
      opacity: 0.32
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#drop-shadow-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.24,197.81c0,2.92-2.37,5.3-5.3,5.3s-5.3-2.37-5.3-5.3,2.37-5.3,5.3-5.3,5.3,2.37,5.3,5.3Z",
    style: {
      fill: "url(#linear-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.68,197.81c0,2.07-1.68,3.74-3.74,3.74s-3.74-1.68-3.74-3.74,1.68-3.74,3.74-3.74,3.74,1.68,3.74,3.74Z",
    style: {
      fill: "url(#linear-gradient-10)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      opacity: 0.32
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 62.63,
    y: 180.08,
    width: 29.31,
    height: 3.74,
    style: {
      fill: "#c15f5f",
      mixBlendMode: "multiply",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.67,181.95c0,1.74-1.41,3.15-3.15,3.15s-3.15-1.41-3.15-3.15,1.41-3.15,3.15-3.15,3.15,1.41,3.15,3.15Z",
    style: {
      fill: "#c15f5f",
      mixBlendMode: "multiply",
      opacity: 0.55
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      opacity: 0.32
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 62.63,
    y: 195.94,
    width: 29.31,
    height: 3.74,
    style: {
      fill: "#c15f5f",
      mixBlendMode: "multiply",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.67,197.81c0,1.74-1.41,3.15-3.15,3.15s-3.15-1.41-3.15-3.15,1.41-3.15,3.15-3.15,3.15,1.41,3.15,3.15Z",
    style: {
      fill: "#c15f5f",
      mixBlendMode: "multiply",
      opacity: 0.55
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 256.59,
    y: 143.8,
    width: 99.67,
    height: 72.11,
    rx: 8.6,
    ry: 8.6,
    style: {
      fill: "url(#linear-gradient-11)",
      filter: "url(#drop-shadow-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.38,192.37v11.42c0,2.89-2.34,5.23-5.23,5.23h-75.44c-2.89,0-5.24-2.34-5.24-5.23v-13.19c0-1.28,.47-2.51,1.31-3.46l17.49-19.81c2.03-2.3,5.6-2.37,7.71-.15l18.16,19.06c1.97,2.07,5.23,2.18,7.34,.24l11-10.12c1.95-1.8,4.95-1.85,6.96-.12l14.12,12.15c1.16,.99,1.82,2.44,1.82,3.97Z",
    style: {
      fill: "url(#linear-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.57,161.05c0,3.74-3.03,6.77-6.77,6.77s-6.77-3.03-6.77-6.77,3.03-6.77,6.77-6.77,6.77,3.03,6.77,6.77Z",
    style: {
      fill: "url(#linear-gradient-13)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 255.27,
    y: 27.09,
    width: 102.3,
    height: 86.19,
    rx: 11.21,
    ry: 11.21,
    style: {
      fill: "url(#linear-gradient-14)",
      filter: "url(#drop-shadow-6)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M268.41,73.16s7.16-7.39,10.64-10.57c2.49-2.27,4.69-4.67,8.15-4.67,8.3,0,9.74,10.52,16.01,10.52s8.11-14.61,18.07-14.61,9.22,10.92,18.07,10.92",
    style: {
      fill: "none",
      filter: "url(#drop-shadow-7)",
      stroke: "url(#linear-gradient-15)",
      strokeMiterlimit: 10,
      strokeWidth: "2.05px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.36,64.05c0,1.93-1.57,3.5-3.5,3.5s-3.5-1.57-3.5-3.5,1.57-3.5,3.5-3.5,3.5,1.57,3.5,3.5Z",
    style: {
      fill: "none",
      filter: "url(#drop-shadow-8)",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "2.05px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 286.1,
    y: 86.03,
    width: 12.15,
    height: 3.09,
    style: {
      fill: "url(#linear-gradient-16)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.1,
    y: 92.94,
    width: 8.46,
    height: 1.97,
    style: {
      fill: "#9f9ffb",
      mixBlendMode: "multiply",
      opacity: 0.71
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.1,
    y: 97.35,
    width: 19.23,
    height: 1.97,
    style: {
      fill: "#9f9ffb",
      mixBlendMode: "multiply",
      opacity: 0.71
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M274.73,84.85c-4.71,0-8.53,3.81-8.53,8.52,0,.86,.13,1.7,.36,2.48,1.06,3.51,4.32,6.06,8.17,6.06,4.71,0,8.53-3.82,8.53-8.54s-3.82-8.52-8.53-8.52Zm0,14.23c-2.58,0-4.76-1.71-5.46-4.05-.16-.52-.25-1.08-.25-1.66,0-3.16,2.56-5.71,5.71-5.71s5.71,2.56,5.71,5.71-2.56,5.71-5.71,5.71Z",
    style: {
      fill: "#9f9ffb",
      mixBlendMode: "multiply",
      opacity: 0.71
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.26,93.37c0,4.72-3.82,8.54-8.53,8.54-3.84,0-7.11-2.56-8.17-6.06l2.7-.82c.71,2.34,2.89,4.05,5.46,4.05,3.16,0,5.71-2.56,5.71-5.71s-2.56-5.71-5.71-5.71v-2.81c4.71,0,8.53,3.81,8.53,8.52Z",
    style: {
      fill: "url(#linear-gradient-17)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 328.71,
    y: 86.03,
    width: 12.15,
    height: 3.09,
    style: {
      fill: "url(#linear-gradient-18)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.71,
    y: 92.94,
    width: 8.46,
    height: 1.97,
    style: {
      fill: "#9f9ffb",
      mixBlendMode: "multiply",
      opacity: 0.71
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.71,
    y: 97.35,
    width: 19.23,
    height: 1.97,
    style: {
      fill: "#9f9ffb",
      mixBlendMode: "multiply",
      opacity: 0.71
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M317.34,84.85h0c-4.7,0-8.52,3.81-8.52,8.52s3.82,8.54,8.52,8.54c4.08,0,7.48-2.85,8.34-6.67,.14-.6,.21-1.23,.21-1.87,0-4.71-3.81-8.51-8.53-8.52Zm0,14.23c-3.15,0-5.7-2.56-5.7-5.71s2.56-5.71,5.7-5.71h0c3.17,0,5.71,2.56,5.71,5.71,0,.43-.05,.86-.15,1.25-.56,2.56-2.84,4.46-5.57,4.46Z",
    style: {
      fill: "#9f9ffb",
      mixBlendMode: "multiply",
      opacity: 0.71
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.87,93.37c0,.64-.07,1.27-.21,1.87l-2.76-.62c.1-.39,.15-.82,.15-1.25,0-3.16-2.55-5.7-5.71-5.71v-2.81c4.72,0,8.53,3.81,8.53,8.52Z",
    style: {
      fill: "url(#linear-gradient-19)"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 267.71,
    y: 37.25,
    width: 20.67,
    height: 2.82,
    style: {
      fill: "#9f9ffb",
      mixBlendMode: "multiply",
      opacity: 0.71
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.71,
    y: 43.99,
    width: 31.53,
    height: 2.83,
    style: {
      fill: "#9f9ffb",
      mixBlendMode: "multiply",
      opacity: 0.71
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 123.98,
    y: 44.48,
    width: 100.1,
    height: 20.34,
    rx: 5.26,
    ry: 5.26,
    style: {
      fill: "url(#linear-gradient-20)",
      filter: "url(#drop-shadow-9)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 132.82,
    y: 48.69,
    width: 12.05,
    height: 12.05,
    rx: 2.79,
    ry: 2.79,
    style: {
      fill: "url(#linear-gradient-21)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.18,
    y: 48.69,
    width: 12.05,
    height: 12.05,
    rx: 2.79,
    ry: 2.79,
    style: {
      fill: "url(#linear-gradient-22)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.58,
    y: 48.69,
    width: 12.05,
    height: 12.05,
    rx: 2.79,
    ry: 2.79,
    style: {
      fill: "url(#linear-gradient-23)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.86,
    y: 48.69,
    width: 12.05,
    height: 12.05,
    rx: 2.79,
    ry: 2.79,
    style: {
      fill: "url(#linear-gradient-24)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.86,
    y: 48.69,
    width: 12.05,
    height: 12.05,
    rx: 2.79,
    ry: 2.79,
    style: {
      fill: "url(#linear-gradient-25)"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeImage2);
export default __webpack_public_path__ + "static/media/home_image_2.3645b1654b75805ace01872b3655de49.svg";
export { ForwardRef as ReactComponent };